import { useEffect } from "react";
import { HttpClientError } from "../../../providers/HttpClient";
import useCancelFinalizedPayslipsApiService from "../services/api/CancelFinalizedPayslipsApiService";
import { queryClient } from "../../../App";
import { useToasts } from "../../../providers/notifications/ToastsContext";

export default function CancelFinalizedPayslipsHook(
  documentNamePlural: string
): {
  cancelFinalizedPayslips: (request: number) => void;
} {
  const { showToast } = useToasts();
  const { isSuccess, isError, mutate, error } =
    useCancelFinalizedPayslipsApiService();

  const cancelFinalizedPayslips = (request: number): void => {
    mutate({ request, documentNamePlural });
  };
  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "cancel_finalized_payslips_failed",
        data: {
          document_name: documentNamePlural,
          message: HttpClientError(error),
        },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess) {
      showToast({
        strapiId: "cancel_finalized_payslips_success",
        data: { document_name: documentNamePlural },
      });
      queryClient.invalidateQueries(["DocumentUploadListApiService"]);
    }
  }, [isSuccess]);

  return { cancelFinalizedPayslips };
}
